import Modal from "@Atom/Modal";
import React from "react";
import style from "./style.module.scss";
import InputText from "@Atom/InputText";
import Button from "@Atom/Button";
import FileUploadSuccess from "@Molecule/FileUploadSuccessModal";
export default function ReedemCodeModal({
  onChange,
  value,
  onSubmit,
  isOpen,
  onClose,
  disabledClose = false,
  isError,
  setIsError,
}) {
  return (
    <div>
      <Modal isOpen={isOpen}>
        <div className={style.container}>
          <div className={style.headerCard}>
            <h1>Reedem Code</h1>
            <p>
              Silahkan masukaan reedem code yang Anda gunakan saat pembelian
              kelas ini untuk dapat melanjutkan
            </p>
          </div>
          <div className={style.mainCard}>
            <InputText
              required={true}
              labelValue="Reedem Code"
              htmlFor={"reedem code"}
              id={"reedem code"}
              placeholder="Reedem Code"
              onChange={(e) => {
                onChange(e);
              }}
              value={value}
              isError={!!isError}
            />
            {!!isError && <p className={style.isError}>{isError}</p>}
          </div>
          <div className={style.buttonCard}>
            {!disabledClose && (
              <div className={style.buttonBack} onClick={onClose}>
                <span>Kembali</span>
              </div>
            )}
            <Button
              onClick={onSubmit}
              text={"Submit"}
              textSize="l"
              textWidth="semibold"
            />
          </div>
        </div>
      </Modal>
    </div>
  );
}
